import React, { useState } from 'react'

import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'

import NonIdealState from '@components/shared/NonIdealState'
import emptyScoresSvgDark from '@images/empty-scores-dark.svg'
import emptyScoresSvg from '@images/empty-scores.svg'
import ScoreService from '@services/ScoreService'
import { useSession } from '@stores/globalData/globalData.store'

const MyScoresEmptyState: React.FC = () => {
  const { t } = useTranslation()
  const session = useSession()
  const [searchParams] = useSearchParams()

  // Simple state to disable create score button when clicking and page is loading
  const [navigating, setNavigating] = useState(false)

  const term = searchParams.get('query')
  if (term) {
    return (
      <NonIdealState
        title={t('content.empty.scoresSearch.title', { term })}
        subtitle={t('content.empty.scoresSearch.subtitle')}
        icon="myscores"
      />
    )
  }

  return (
    <NonIdealState
      title={t('content.empty.scores.title')}
      action={{
        type: 'button',
        text: navigating ? t('messages.creating') : t('content.empty.scores.action'),
        onClick: async () => {
          setNavigating(true)
          try {
            await ScoreService.createNewScore(session)
          } catch (_) {
            setNavigating(false)
          }
        },
      }}
      imageContent={
        <>
          <img
            src={emptyScoresSvg}
            role="image"
            alt="Empty scores"
            width={120}
            className="mb-3 dark:hidden"
          />
          <img
            src={emptyScoresSvgDark}
            role="image"
            alt="Empty scores"
            width={120}
            className="mb-3 hidden dark:block"
          />
        </>
      }
    />
  )
}

export default MyScoresEmptyState
